import { NotificationBannerConfig, NotificationBannerFeature } from '../../../domain/chat/models/NotificationBanner';

export interface NotificationBannerState {
    showNotificationDialog: boolean;
    carouselIndex: number;
    showFeatureHighlight: boolean;
    featureHighlightData: NotificationBannerFeature | null;
    shouldScrollToFeature: boolean;
    bannerConfig: Partial<NotificationBannerConfig>;
}

export const initialNotificationBannerState: NotificationBannerState = {
    showNotificationDialog: false,
    carouselIndex: 0,
    showFeatureHighlight: false,
    featureHighlightData: null,
    shouldScrollToFeature: false,
    bannerConfig: {},
};
